import { Component } from "@angular/core";

@Component({
    selector: 'app-shared', 
    templateUrl: './shared.component.html'
   
    })
    export class SharedComponent {
    }